/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Your_PackagesInputs */

const en_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your packages`)
};

const es_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus paquetes`)
};

const de_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Pakete`)
};

const zh_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的课程套餐`)
};

const ar_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`باقاتك`)
};

const fr_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos forfaits`)
};

const vi_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói của bạn`)
};

const sw_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vifurushi vyako`)
};

const th_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คเกจของคุณ`)
};

const bs_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaši paketi`)
};

const ja_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンパッケージ`)
};

const ko_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 패키지`)
};

const pt_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus pacotes`)
};

const it_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi pacchetti`)
};

const sv_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dina paket`)
};

const nl_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw pakketten`)
};

const da_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine pakker`)
};

const nb_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine pakker`)
};

const fi_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketit`)
};

const pl_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje pakiety`)
};

const ru_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши пакеты занятий`)
};

const tr_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paketleriniz`)
};

const hi_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका पैकेज`)
};

const id_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Anda`)
};

const ms_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakej anda`)
};

const cs_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše balíčky`)
};

const el_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τα πακέτα σας`)
};

const he_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החבילות שלכם`)
};

const af_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jou pakkette`)
};

const hu_booking_your_packages = /** @type {(inputs: Booking_Your_PackagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csomagjaid`)
};

/**
* | output |
* | --- |
* | "Your packages" |
*
* @param {Booking_Your_PackagesInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_your_packages = /** @type {((inputs?: Booking_Your_PackagesInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Your_PackagesInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_your_packages(inputs)
	if (locale === "de") return de_booking_your_packages(inputs)
	if (locale === "zh") return zh_booking_your_packages(inputs)
	if (locale === "ar") return ar_booking_your_packages(inputs)
	if (locale === "fr") return fr_booking_your_packages(inputs)
	if (locale === "vi") return vi_booking_your_packages(inputs)
	if (locale === "sw") return sw_booking_your_packages(inputs)
	if (locale === "th") return th_booking_your_packages(inputs)
	if (locale === "bs") return bs_booking_your_packages(inputs)
	if (locale === "ja") return ja_booking_your_packages(inputs)
	if (locale === "ko") return ko_booking_your_packages(inputs)
	if (locale === "pt") return pt_booking_your_packages(inputs)
	if (locale === "it") return it_booking_your_packages(inputs)
	if (locale === "sv") return sv_booking_your_packages(inputs)
	if (locale === "nl") return nl_booking_your_packages(inputs)
	if (locale === "da") return da_booking_your_packages(inputs)
	if (locale === "nb") return nb_booking_your_packages(inputs)
	if (locale === "fi") return fi_booking_your_packages(inputs)
	if (locale === "pl") return pl_booking_your_packages(inputs)
	if (locale === "ru") return ru_booking_your_packages(inputs)
	if (locale === "tr") return tr_booking_your_packages(inputs)
	if (locale === "hi") return hi_booking_your_packages(inputs)
	if (locale === "id") return id_booking_your_packages(inputs)
	if (locale === "ms") return ms_booking_your_packages(inputs)
	if (locale === "cs") return cs_booking_your_packages(inputs)
	if (locale === "el") return el_booking_your_packages(inputs)
	if (locale === "he") return he_booking_your_packages(inputs)
	if (locale === "af") return af_booking_your_packages(inputs)
	if (locale === "hu") return hu_booking_your_packages(inputs)
	return en_booking_your_packages(inputs)
});